module.exports = __webpack_public_path__ + "img/profile_box_height.7b3cdeea.svg";